export enum TeachAndRepeatResolveType{
    WaitForMaintenance = "WaitForMaintenance",
    FollowAnyPath = "FollowAnyPath",
    DisregardPath = "DisregardPath",
}

export const getTeachAndRepeatResolveTypeList = Object.values(TeachAndRepeatResolveType);